// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import Router from 'next/router';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import ManageInventory from '@/components/inventory/manage';
import BillingService from '@/services/billing-service';
import SubscriptionContext from '@/utils/subscription-context';
import { createFileRoute } from '@tanstack/react-router'



function CreateInventory() {  

    const subscriptionContext = useContext(SubscriptionContext);
    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

    const getAccessStatus = async () => {
        const [subscriptionInfo, _] = await BillingService.getSubcriptionInfo(subscriptionContext);
        if (subscriptionInfo) {
          setAccessStatus(subscriptionInfo.AccessStatus);
        }
    };
    
      useEffect(() => {
        getAccessStatus();
      }, []);
      
      useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
          Helper.nextRouter(Router.replace,"/");
        }
      }, [accessStatus]);

    return (
        <div>
            <ManageInventory isNew={true} accessStatus={accessStatus} />           
        </div>
    );
}

export default CreateInventory;

export const Route = createFileRoute('/_authenticated/inventory/create')({ component: CreateInventory })
